module.exports = __webpack_public_path__ + "img/sadboy.a4ac778b.svg";